import React from 'react'
import { connect } from 'react-redux'
import * as actions from './actions'
import { executeIfNotEqual } from '../../util'

const crudTypes = {
  LIST: 'LIST',
  SHOW: 'SHOW'
}
export { crudTypes }

const familyPaths = [
  '/family',
  '/family/:id'
]
export { familyPaths }

class FamilyRoutingContainer extends React.Component {
  componentDidMount(){ this.syncStateWithRoute() }
  componentDidUpdate(){ this.syncStateWithRoute() }

  syncStateWithRoute() {
    const { match, dispatch, crudAction, familyId } = this.props

    // Set primary crud action
    if(match.params.id) {
      executeIfNotEqual(
        familyId, match.params.id, ()=>dispatch(actions.setProfileId(match.params.id))
      )
      executeIfNotEqual(
        crudAction, crudTypes.SHOW, ()=>dispatch(actions.setFamilyCrudAction(crudTypes.SHOW))
      )
    } else {
      executeIfNotEqual(
        crudAction, crudTypes.LIST, ()=>{
          dispatch(actions.setFamilyCrudAction(crudTypes.LIST))
          dispatch(actions.setProfileId(''))
        }
      )
    }
  }

  render() {
    return(
      React.cloneElement(React.Children.only(this.props.children))
    )
  }
}

const mapStateToProps = state => {
  return state.familyrenRouting
}

export { FamilyRoutingContainer }
export default connect(mapStateToProps)(FamilyRoutingContainer)
